import { RouteRecordRaw } from "vue-router";
import { PermissionEnum } from "@altertec_gparn/lib";

export const certificationsDeliveriesRoutes: RouteRecordRaw = {
  path: "deliveries",
  name: "Deliveries Layout",
  redirect: { name: "Deliveries" },
  meta: { permissions: [PermissionEnum.CERTIFICATIONS_DELIVERIES] },
  component: () => import("@/layouts/EmptyLayout.vue"),
  children: [
    {
      path: "list",
      name: "Deliveries",
      component: () => import("@/views/auth/certifications/deliveries/DeliveryList.vue"),
    },
  ],
};
